import React, { useEffect, useRef, useState } from 'react'
import { getOperationView, getProducer, getTypes, textTypes } from '@helpers/helper.filters'
import { useDispatch, useSelector } from 'react-redux'
// import { redux_updateOrders } from '@slices/propertiesSlice';
import useQueryProperties from '@hooks/useQueryProperties'
import { RealEstateDataPageComponentData, StatePropertiesSlice } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Filters_2 from '@components/filtersBar/2'
import { reduxUpdateOrderBy } from '@slices/propertiesSlice'

const isBrowser = typeof window !== 'undefined'

const Handle_Filters_2 = (props: RealEstateDataPageComponentData) => {
  const { isDemo, global_data } = props
  const { spanText, locationsAdv, lowPrice } = props

  const [orders, setOrders] = useState({ order: 'desc', order_by: 'id' })

  const [menu, setMenu] = useState(false)

  const MediaPro = false
  const selectorOrder = useRef<any>()
  const dispatch = useDispatch()
  const { filters, offset, coordinates, polygonCoordinates } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )
  const tokkoKey = global_data.pageConfig.keys.tokko
  const {
    properties,
    isLoading: isLoadingProperties,
    isFetching: isFetchingProperties,
  } = useQueryProperties({ filters, polygonCoordinates, coordinates, orders, offset, tokkoKey })

  function traductorSelect() {
    switch (selectorOrder?.current?.value) {
      case '0':
        setOrders({ order: 'desc', order_by: 'price' })
        break
      case '1':
        setOrders({ order: 'asc', order_by: 'price' })
        break
      case '2':
        setOrders({ order: 'desc', order_by: 'id' })
        break
      case '3':
        setOrders({ order: 'asc', order_by: 'id' })
        break
      case '4':
        setOrders({ order: 'desc', order_by: 'total_surface' })
        break
      case '5':
        setOrders({ order: 'asc', order_by: 'total_surface' })
        break
    }
  }

  useEffect(() => {
    dispatch(reduxUpdateOrderBy(orders))
  }, [orders])

  function toggleMenu() {
    document.getElementsByTagName('html')[0].classList.toggle('overflow-hidden')
    return setMenu(!menu)
  }

  if (isBrowser) {
    window.addEventListener('scroll', function () {
      const header = document.querySelector('#header') as HTMLElement
      const handle_filter = document.querySelector('#handle-filter-bar') as HTMLElement
      let content = document.querySelector('body') as HTMLElement
      if (handle_filter) {
        if (window.scrollY > 0) {
          handle_filter.classList.add('position-fixed')
          handle_filter.style.top = header?.clientHeight + 'px'
          content.style.marginTop = header?.clientHeight + handle_filter?.clientHeight + 'px'
        } else {
          handle_filter.style.top = '0px'
          content.style.marginTop = '0'
          handle_filter.classList.remove('position-fixed')
        }
      }
    })
  }

  return (
    <>
      {spanText && (
        <div
          onClick={() => toggleMenu()}
          id="openFilter"
          className="d-lg-none align-items-center position-fixed filter-mobile d-flex justify-content-center"
        >
          <i className="icon-filters me-4"></i>
          <h4 className="mb-0">{spanText}</h4>
        </div>
      )}
      <Container
        fluid
        id="handle-filter-bar"
        className="pt-lg-3 pt-5 px-lg-4 handle-filter-bar b"
      >
        <Row>
          <Col
            xs={12}
            className="mt-lg-3"
          ></Col>
          <Col
            lg={6}
            className="mt-0 mt-lg-0"
          >
            <div className="section-title pt-0 pt-lg-0 pb-lg-0">
              <h1 className={!getOperationView(filters) ? 'mt-lg-3 skeleton' : ''}>
                {filters.type?.length > 0
                  ? textTypes(filters.type.map((a) => a.name))
                  : 'Propiedades'}{' '}
                en {getOperationView(filters)}{' '}
                <div className="d-inline-block text-capitalize">{getProducer(filters)}</div>
              </h1>
              {/* <h1 className={!getOperationView(filters) ? "mt-lg-3 skeleton" : ''}>{filters.type?.length > 0 ? textTypes(filters.type) : 'Propiedades'} en {getOperationView(filters)} <div className="d-inline-block text-capitalize">{ getProducer(filters)}</div></h1> */}
              <br className="d-lg-none" />
              <h5 className={(isLoadingProperties && 'skeleton my-2') + ' d-lg-none'}>
                {isLoadingProperties || isFetchingProperties
                  ? 'Cargando'
                  : properties?.meta?.total_count}{' '}
                resultados totales de búsqueda.{' '}
              </h5>
            </div>
          </Col>
          {spanText && (
            <Col
              sm={6}
              className="d-lg-flex d-none align-items-center justify-content-end"
            >
              <div
                onClick={() => toggleMenu()}
                id="openFilter"
                className="d-lg-flex align-items-center justify-content-end"
              >
                <i className="icon-filters me-4"></i>
                <h4 className="mb-0">{spanText}</h4>
              </div>
            </Col>
          )}
          <Col
            xs={12}
            className="justify-content-end d-flex align-items-center mt-lg-2 mb-lg-2"
            id="orderBy"
          >
            <h5
              className={(isLoadingProperties && 'skeleton') + ' d-none d-lg-block col-6 mb-lg-0'}
            >
              {isLoadingProperties || isFetchingProperties
                ? 'Cargando'
                : properties?.meta?.total_count}{' '}
              resultados totales de búsqueda.{' '}
            </h5>
            <div className="content-select col-lg-6 text-end me-0">
              <select
                ref={selectorOrder}
                onChange={() => traductorSelect()}
                className="text-end me-lg-0"
                name="orderby"
                id="sort"
              >
                <option value="2">Publicaciones más recientes</option>
                <option value="3">Publicaciones más antiguas</option>
                <option value="0">Mayor precio</option>
                <option value="1">Menor precio</option>
                <option value="4">Mayor superficie</option>
                <option value="5">Menor superficie</option>
              </select>
              <i></i>
            </div>
          </Col>
          <Filters_2
            locationsAdv={locationsAdv || false}
            lowPrice={lowPrice || false}
            menu={menu}
            setMenu={setMenu}
            global_data={global_data}
          />
        </Row>
      </Container>
    </>
  )
}

export default Handle_Filters_2
